import { Type } from 'class-transformer';
import { IsNotEmpty, IsArray } from 'class-validator';

import { VacationApprover } from './vacation-approver.dto';

const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
  groups: ['form'],
};

export class CreateVacationCoordinationDto {
  @Type(() => VacationApprover)
  @IsArray()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  approvers: VacationApprover[];
}
